import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_09f38048 from 'nuxt_plugin_plugin_09f38048' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_5d5f10e6 from 'nuxt_plugin_bootstrapvue_5d5f10e6' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_plugin_4fe4e8a6 from 'nuxt_plugin_plugin_4fe4e8a6' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_libpluginb19edd08_181e491f from 'nuxt_plugin_libpluginb19edd08_181e491f' // Source: ./lib.plugin.b19edd08.js (mode: 'all')
import nuxt_plugin_markdownit_e50a6440 from 'nuxt_plugin_markdownit_e50a6440' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_workbox_4e15ecfa from 'nuxt_plugin_workbox_4e15ecfa' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_0b979a0d from 'nuxt_plugin_metaplugin_0b979a0d' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_103f3f81 from 'nuxt_plugin_iconplugin_103f3f81' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_deviceplugin_83619e2e from 'nuxt_plugin_deviceplugin_83619e2e' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_gtm_6a08ddb4 from 'nuxt_plugin_gtm_6a08ddb4' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_onesignalclient_b1c29494 from 'nuxt_plugin_onesignalclient_b1c29494' // Source: ../plugins/onesignal.client.js (mode: 'client')
import nuxt_plugin_vuemq_b8541150 from 'nuxt_plugin_vuemq_b8541150' // Source: ../plugins/vue-mq.js (mode: 'all')
import nuxt_plugin_router_3f7e063d from 'nuxt_plugin_router_3f7e063d' // Source: ../plugins/router (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_checkUpdate_35e82506 from 'nuxt_plugin_checkUpdate_35e82506' // Source: ../plugins/checkUpdate (mode: 'all')
import nuxt_plugin_filters_14a52510 from 'nuxt_plugin_filters_14a52510' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_lazyload_2b09a22e from 'nuxt_plugin_lazyload_2b09a22e' // Source: ../plugins/lazyload.js (mode: 'all')
import nuxt_plugin_localStorage_08604484 from 'nuxt_plugin_localStorage_08604484' // Source: ../plugins/localStorage (mode: 'all')
import nuxt_plugin_storeCtl_2bc4ffc9 from 'nuxt_plugin_storeCtl_2bc4ffc9' // Source: ../plugins/storeCtl.js (mode: 'all')
import nuxt_plugin_v2touch_3c3492bc from 'nuxt_plugin_v2touch_3c3492bc' // Source: ../plugins/v2-touch (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vueclipboard2_33d4a2f7 from 'nuxt_plugin_vueclipboard2_33d4a2f7' // Source: ../plugins/vue-clipboard2 (mode: 'all')
import nuxt_plugin_bugsnag_6b5683c1 from 'nuxt_plugin_bugsnag_6b5683c1' // Source: ../plugins/bugsnag (mode: 'all')
import nuxt_plugin_chunkerrorhandler_18a452b1 from 'nuxt_plugin_chunkerrorhandler_18a452b1' // Source: ../plugins/chunk-error-handler (mode: 'client')
import nuxt_plugin_payjp_22f2167a from 'nuxt_plugin_payjp_22f2167a' // Source: ../plugins/payjp (mode: 'client')
import nuxt_plugin_chartTheme_4a0e8502 from 'nuxt_plugin_chartTheme_4a0e8502' // Source: ../plugins/chartTheme (mode: 'client')
import nuxt_plugin_confirmDialogStyle_7299e75d from 'nuxt_plugin_confirmDialogStyle_7299e75d' // Source: ../plugins/confirmDialogStyle (mode: 'client')
import nuxt_plugin_keyboardOperation_ac493468 from 'nuxt_plugin_keyboardOperation_ac493468' // Source: ../plugins/keyboardOperation (mode: 'client')
import nuxt_plugin_supportWidget_821bf502 from 'nuxt_plugin_supportWidget_821bf502' // Source: ../plugins/supportWidget (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Gym's -AI搭載 店舗管理-","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"http-equiv":"content-language","content":"ja"},{"name":"viewport","content":"width=device-width,initial-scale=1.0,minimum-scale=1.0,user-scalable=no"},{"hid":"description","name":"description","content":"AI搭載 店舗管理"},{"hid":"og:site_name","property":"og:site_name","content":"Gym's"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fcp.gyms.jp"},{"hid":"og:title","property":"og:title","content":"Gym's"},{"hid":"og:description","property":"og:description","content":"AI搭載 店舗管理"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fcp.gyms.jp\u002Fog.png"},{"name":"twitter:card","content":"summary"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ficon.png"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fgyms-api.saucer-saas.com"},{"rel":"preconnect","href":"https:\u002F\u002Fgyms-api.saucer-saas.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fgyms-stg-api.saucer-saas.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.jsdelivr.net"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"async":true,"src":"https:\u002F\u002Fcdn.onesignal.com\u002Fsdks\u002FOneSignalSDK.js","hid":"onesignal"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-K44WPRB2')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-K44WPRB2&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_09f38048 === 'function') {
    await nuxt_plugin_plugin_09f38048(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_5d5f10e6 === 'function') {
    await nuxt_plugin_bootstrapvue_5d5f10e6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_4fe4e8a6 === 'function') {
    await nuxt_plugin_plugin_4fe4e8a6(app.context, inject)
  }

  if (typeof nuxt_plugin_libpluginb19edd08_181e491f === 'function') {
    await nuxt_plugin_libpluginb19edd08_181e491f(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_e50a6440 === 'function') {
    await nuxt_plugin_markdownit_e50a6440(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_4e15ecfa === 'function') {
    await nuxt_plugin_workbox_4e15ecfa(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_0b979a0d === 'function') {
    await nuxt_plugin_metaplugin_0b979a0d(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_103f3f81 === 'function') {
    await nuxt_plugin_iconplugin_103f3f81(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_83619e2e === 'function') {
    await nuxt_plugin_deviceplugin_83619e2e(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_6a08ddb4 === 'function') {
    await nuxt_plugin_gtm_6a08ddb4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onesignalclient_b1c29494 === 'function') {
    await nuxt_plugin_onesignalclient_b1c29494(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemq_b8541150 === 'function') {
    await nuxt_plugin_vuemq_b8541150(app.context, inject)
  }

  if (typeof nuxt_plugin_router_3f7e063d === 'function') {
    await nuxt_plugin_router_3f7e063d(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_checkUpdate_35e82506 === 'function') {
    await nuxt_plugin_checkUpdate_35e82506(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_14a52510 === 'function') {
    await nuxt_plugin_filters_14a52510(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyload_2b09a22e === 'function') {
    await nuxt_plugin_lazyload_2b09a22e(app.context, inject)
  }

  if (typeof nuxt_plugin_localStorage_08604484 === 'function') {
    await nuxt_plugin_localStorage_08604484(app.context, inject)
  }

  if (typeof nuxt_plugin_storeCtl_2bc4ffc9 === 'function') {
    await nuxt_plugin_storeCtl_2bc4ffc9(app.context, inject)
  }

  if (typeof nuxt_plugin_v2touch_3c3492bc === 'function') {
    await nuxt_plugin_v2touch_3c3492bc(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclipboard2_33d4a2f7 === 'function') {
    await nuxt_plugin_vueclipboard2_33d4a2f7(app.context, inject)
  }

  if (typeof nuxt_plugin_bugsnag_6b5683c1 === 'function') {
    await nuxt_plugin_bugsnag_6b5683c1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chunkerrorhandler_18a452b1 === 'function') {
    await nuxt_plugin_chunkerrorhandler_18a452b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_payjp_22f2167a === 'function') {
    await nuxt_plugin_payjp_22f2167a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chartTheme_4a0e8502 === 'function') {
    await nuxt_plugin_chartTheme_4a0e8502(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_confirmDialogStyle_7299e75d === 'function') {
    await nuxt_plugin_confirmDialogStyle_7299e75d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_keyboardOperation_ac493468 === 'function') {
    await nuxt_plugin_keyboardOperation_ac493468(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_supportWidget_821bf502 === 'function') {
    await nuxt_plugin_supportWidget_821bf502(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
